import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useGlobalConfigContext } from '../../../global-config'
import { SeoHeadDescriptionMetas, SeoHeadTitleMetas } from '../../../seo'
import { urlResolverNfcLandingPage } from '../../../url-handling'

export const NfcLandingPageSeoHeadTags: FC = () => {
  const intl = useIntl()
  const config = useGlobalConfigContext()

  const titleContent = intl.formatMessage({ id: 'nfc.meta.title' })
  const descriptionContent = intl.formatMessage({
    id: 'nfc.meta.description',
  })

  return (
    <>
      <title>{titleContent}</title>
      <link
        href={`${config.shopUrl}${urlResolverNfcLandingPage(config)}`}
        rel="canonical"
      />
      <SeoHeadTitleMetas title={titleContent} />
      <SeoHeadDescriptionMetas description={descriptionContent} />
      <meta
        content="e-rezept auf gesundheitskarte, elektronische gesundheitskarte e-rezept, e rezept mit egk"
        name="keywords"
      />
    </>
  )
}
